import React from 'react'
import axios from 'axios'
import { useState } from 'react'
// import Navbar from '../Navbar'
const SERVER_URL = process.env.REACT_APP_SERVER_URL

const AddProductModal = ({ categories, modal, setModal }) => {
    const [fData, setFdata] = useState({
        pName: "",
        pDescription: "",
        pStatus: "Active",
        pImage: [], // Initial value will be null or empty array
        pCategory: "",
        pPrice: "",
        pOffer: 0,
        pType: "",
        pQuantity: "",
        success: false,
        error: false,
    });


    const alert = (msg, type) => (
        <div className={`bg-${type} my-2 py-2 px-4 w-100`}>{msg}</div>
    );

    if (fData.error || fData.success) {
        setTimeout(() => {
            setFdata({ ...fData, success: false, error: false });
        }, 2000);
    }


    const formSubmitHandler = (e) => {
        e.preventDefault();
        console.log(fData);
        if (!fData.pImage) {
            setFdata({ ...fData, error: "Please upload at least 2 image" });

        }
        let formData = new FormData();
        for (const file of fData.pImage) {
            formData.append("pImage", file);
        }
        // console.log(formData);
        /* Most important part for uploading multiple image  */
        formData.append("pName", fData.pName);
        formData.append("pDescription", fData.pDescription);
        formData.append("pStatus", fData.pStatus);
        formData.append("pCategory", fData.pCategory);
        formData.append("pType", fData.pType);
        formData.append("pQuantity", fData.pQuantity);
        formData.append("pPrice", fData.pPrice);
        formData.append("pOffer", fData.pOffer);
        if (localStorage.getItem("userTokenTime") != null) {
            axios
                .post(
                    SERVER_URL +
                    "/api/admin/add-product",
                    formData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization:
                                "Bearer " +
                                JSON.parse(localStorage.getItem("userTokenTime")).token,
                        },
                    }
                )
                .then((res) => {
                    console.log(res.data);
                    if (res.data.error) {
                        setFdata({ ...fData, success: false, error: res.data.error });
                    }
                    else {
                        setFdata({
                            pName: "",
                            pDescription: "",
                            pStatus: "Active",
                            pImage: [], // Initial value will be null or empty array
                            pCategory: "",
                            pPrice: "",
                            pOffer: 0,
                            pType: "",
                            pQuantity: "",
                            success: false,
                            error: false,
                        });
                        setModal(false);
                    }

                }).catch((e) => {
                    console.log(e);
                });
        }
    };
    return (
        <React.Fragment>
            <div className={`${modal ? "" : "mhidden"} backdrop`}></div>
            <div
                className={`${modal ? "" : "mhidden"} addmodel cmodel`}
            >
                <div className="modaldiv relative space-y-4 overflow-y-auto px-4 py-4 md:px-8">
                    <div className="modal__header">
                        <span className="modal__heading">
                            Add Product
                        </span>
                        {/* Close Modal */}
                        <span
                            style={{ background: "#303031" }}
                            onClick={() => setModal(false)}
                            className="modal-close-btn"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                        </span>
                    </div>
                    {fData.error ? alert(fData.error, "red") : ""}
                    {fData.success ? alert(fData.success, "green") : ""}
                    <form className="w-100" >
                        <div className="d-flex">

                            <div className="form__input w-50">
                                <label htmlFor="name">Product Name</label>
                                <input
                                    onChange={(e) =>
                                        setFdata({
                                            ...fData,
                                            success: false,
                                            error: false,
                                            pName: e.target.value,
                                        })
                                    }
                                    value={fData.pName}
                                    className="w-100 px-4 py-2 border focus:outline-none"
                                    type="text"
                                />
                            </div>
                            <div className="form__input w-50 ml-2">
                                <label htmlFor="price">Product Price *</label>
                                <input
                                    value={fData.pPrice}
                                    onChange={(e) =>
                                        setFdata({
                                            ...fData,
                                            error: false,
                                            success: false,
                                            pPrice: e.target.value,
                                        })
                                    }
                                    type="number"
                                    className="w-100 px-4 py-2 border focus:outline-none"
                                    id="price"
                                />
                            </div>

                        </div>
                        <div className="form__input">
                            <label htmlFor="description">Product Description</label>
                            <textarea
                                onChange={(e) =>
                                    setFdata({
                                        ...fData,
                                        success: false,
                                        error: false,
                                        pDescription: e.target.value,
                                    })
                                }
                                value={fData.pDescription}
                                className="px-4 py-2 border focus:outline-none"
                                name="description"
                                id="description"
                                cols={5}
                                rows={2}
                            />
                        </div>

                        {/* Image Field & function */}
                        <div className="form__input">
                            <label htmlFor="name">Product Image</label>
                            <input
                                accept=".jpg, .jpeg, .png, .webp, .avif"
                                onChange={(e) => {
                                    setFdata({
                                        ...fData,
                                        success: false,
                                        error: false,
                                        pImage: [...e.target.files],
                                    });
                                }}
                                className="px-4 py-2 border focus:outline-none"
                                type="file"
                                multiple
                            />
                        </div>
                        <div className="d-flex">
                            <div className="form__input">
                                <label htmlFor="status">Product Type</label>
                                <select
                                    name="status"
                                    value={fData.pType}
                                    onChange={(e) =>{
                                        setFdata({
                                            ...fData,
                                            success: false,
                                            error: false,
                                            pType: e.target.value,
                                        })
                                    }}
                                    className="px-4 py-2 border focus:outline-none"
                                    id="type"
                                >
                                    <option disabled value="">
                                        Select a type
                                    </option>
                                    <option name="type" value="Men">
                                        Men
                                    </option>
                                    <option name="type" value="Women">
                                        Women
                                    </option>
                                    <option name="type" value="Kids">
                                        Kids
                                    </option>
                                </select>
                            </div>
                            <div className="form__input ml-2">
                                <label htmlFor="status">Product Category *</label>
                                <select
                                    value={fData.pCategory}
                                    onChange={(e) =>
                                        setFdata({
                                            ...fData,
                                            error: false,
                                            success: false,
                                            pCategory: e.target.value,
                                        })
                                    }
                                    name="status"
                                    className="px-4 py-2 border focus:outline-none"
                                    id="status"
                                >
                                    <option disabled value="">
                                        Select a category
                                    </option>
                                    {categories.length > 0
                                        ? categories.filter(category => category.cType === fData.pType).map(function (elem) {
                                            return (
                                                <option name="status" value={elem._id} key={elem._id}>
                                                    {elem.cName}
                                                </option>
                                            );
                                        })
                                        : ""}
                                </select>
                            </div>

                        </div>
                        <div className='d-flex'>
                            <div className="form__input" style={{ width: "33.33333%" }}>
                                <label htmlFor="status">Product Status</label>
                                <select
                                    name="status"
                                    onChange={(e) =>
                                        setFdata({
                                            ...fData,
                                            success: false,
                                            error: false,
                                            pStatus: e.target.value,
                                        })
                                    }
                                    className="px-4 py-2 border focus:outline-none"
                                    id="status"
                                >
                                    <option name="status" value="Active">
                                        Active
                                    </option>
                                    <option name="status" value="Disabled">
                                        Disabled
                                    </option>
                                </select>
                            </div>
                            <div className="form__input ml-2" style={{ width: "33.33333%" }}>
                                <label htmlFor="quantity">Product in Stock *</label>
                                <input
                                    value={fData.pQuantity}
                                    onChange={(e) =>
                                        setFdata({
                                            ...fData,
                                            error: false,
                                            success: false,
                                            pQuantity: e.target.value,
                                        })
                                    }
                                    type="number"
                                    className="w-100 px-4 py-2 border focus:outline-none"
                                    id="quantity"
                                />
                            </div>
                            <div className="form__input ml-2" style={{ width: "33.33333%" }}>
                                <label htmlFor="offer">Product Discount (%) *</label>
                                <input
                                    value={fData.pOffer}
                                    onChange={(e) =>
                                        setFdata({
                                            ...fData,
                                            error: false,
                                            success: false,
                                            pOffer: e.target.value,
                                        })
                                    }
                                    type="number"
                                    className="w-100 px-4 py-2 border focus:outline-none"
                                    id="offer"
                                />
                            </div>
                        </div>

                        <div className="create-btn-div">
                            <button
                                style={{ background: "#303031" }}
                                type="submit"
                                className="create__btn"
                                onClick={formSubmitHandler}
                            >
                                Create Product
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddProductModal